import { render } from "./TarjetasView.vue?vue&type=template&id=2f60efad&scoped=true"
import script from "./TarjetasView.vue?vue&type=script&lang=js"
export * from "./TarjetasView.vue?vue&type=script&lang=js"

import "./TarjetasView.vue?vue&type=style&index=0&id=2f60efad&scoped=true&lang=css"

import exportComponent from "/Users/macbookpro/Documents/Github/sinfoapp/sinfoapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f60efad"]])

export default __exports__